var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.32812 3.70312V13.7344C3.375 14.0625 3.28125 14.4375 3.04688 14.7188L0.65625 17.5781V17.9531H7.40625V17.5781L5.01562 14.7188C4.73438 14.4375 4.64062 14.0625 4.6875 13.7344V5.0625L10.5938 18H11.2969L16.4062 5.0625V15.3281C16.4062 15.6094 16.4062 15.6562 16.2188 15.8438L14.3906 17.625V18H23.2969V17.625L21.5156 15.8906C21.375 15.7969 21.2812 15.5625 21.3281 15.375V2.625C21.2812 2.4375 21.375 2.25 21.5156 2.15625L23.2969 0.421875V0H17.0625L12.5625 11.1562L7.5 0H0.9375V0.421875L3.04688 2.95312C3.23438 3.14062 3.375 3.42188 3.32812 3.70312Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.8e86938b93c47482715539c31ac9cdb6.svg";
export { ForwardRef as ReactComponent };